export enum AccessPermissions {
  ClientsMedical = "Administration.Medical",
}
